import HttpClienteSeguroCore from '../../Servicios/HttpClienteSeguroCore';

// Se encacarga de listar Paises
export const listarPaises = (CountryId) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/Ubicacion/Paises/', { CouCountryId: CountryId }).then(response => {
            resolve(response);
        });
    });
};

// Se encacarga de listar ubicaciones nivel 1
export const listarLocation1 = (LocLocationId, CompanyId, UserId) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/Ubicacion/Location1/', { LocLocationId: LocLocationId, CompanyId: CompanyId, UserId: UserId }).then(response => {
            resolve(response);
        });
    });
};

// Se encacarga de listar ubicaciones nivel 2
export const listarLocation2 = (LocLocation2Id, LocLocation1Fk, UserId) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/Ubicacion/Location2/', { LocLocation2Id: LocLocation2Id, LocLocation1Id: LocLocation1Fk, UserId: UserId }).then(response => {
            resolve(response);
        });
    });
};

// Se encacarga de listar ubicaciones nivel 3
export const listarLocation3 = (LocLocation3Id, LocLocation2Fk, UserId) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/Ubicacion/Location3/', { LocLocation3Id: LocLocation3Id, LocLocation2Id: LocLocation2Fk, UserId: UserId }).then(response => {
            resolve(response);
        });
    });
};

// Se encacarga de listar ubicaciones nivel 4
export const listarLocation4 = (LocLocation4Id, LocLocation3Fk, UserId) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/Ubicacion/Location4/', { LocLocation4Id: LocLocation4Id, LocLocation3Id: LocLocation3Fk, UserId: UserId }).then(response => {
            resolve(response);
        });
    });
};

export default listarPaises;